export const apiUrl = process.env.REACT_APP_API_URL || '/api';
export const appTitle = process.env.REACT_APP_TITLE;
export const appVersion = process.env.REACT_APP_VERSION || '';
export const portalTitle = 'Client Portal';
